const requestAnimFrame = window.requestAnimationFrame ||
  window.requestAnimationFrame ||
  ((callback) => window.setTimeout(callback, 1000 / 60));

export { requestAnimFrame };
